import {useId} from "react";
import {SecretInputGroup} from "@/components/SecretInputGroup";

/**
 * One labelled calendar URL, laid out like any other field of a `form-horizontal` panel.
 * The label is tied to the input, so screen readers announce which calendar the URL is for
 * (the legacy JSP rendered these labels without a `for` attribute).
 */
export function CalendarLinkRow({label, url}: {label: string; url: string}) {
	const inputId = useId();

	return (
		<div className="form-group">
			<label className="col-lg-3 control-label text-right" htmlFor={inputId}>
				{label}
			</label>
			<div className="col-lg-9">
				<SecretInputGroup id={inputId} value={url}/>
			</div>
		</div>
	);
}
